import { Formik } from 'formik';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import AnimatedStepWrapper from 'src/features/auth/presentation/components/SignUpStepper/AnimatedStepWrapper';
import VerificationStepper from 'src/features/auth/presentation/components/VerificationStepper/VerificationStepper';
import { VerificationSchema } from 'src/features/auth/presentation/components/validation';

export default function VerificationScreen() {
  const { session } = useAuthContext();

  const initialVerificationData = {
    email: session?.user.email || '',
    phone_number: session?.user.phone_number || '',
  };

  return (
    <AnimatedStepWrapper>
      <Formik
        initialValues={initialVerificationData}
        onSubmit={() => {}}
        validationSchema={VerificationSchema}
        validateOnMount={false}
      >
        <VerificationStepper />
      </Formik>
    </AnimatedStepWrapper>
  );
}
